import { render, staticRenderFns } from "./FormulateBoxSelect.vue?vue&type=template&id=1ef7c31b&"
import script from "./FormulateBoxSelect.js?vue&type=script&lang=js&"
export * from "./FormulateBoxSelect.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/develop.mijnmooiestraat.vlaanderen/pro-develop.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ef7c31b')) {
      api.createRecord('1ef7c31b', component.options)
    } else {
      api.reload('1ef7c31b', component.options)
    }
    module.hot.accept("./FormulateBoxSelect.vue?vue&type=template&id=1ef7c31b&", function () {
      api.rerender('1ef7c31b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Formulate/FormulateBoxSelect/FormulateBoxSelect.vue"
export default component.exports